import { ProcessEnvConfig } from "config/ProcessEnvConfig";
import { CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY } from "./CampaignAnchorConfig";

export const TICKET_CONTENT_PAGE_ANCHOR_KEY = {
  general: {
    sectionKey: "general",
    sectionContent: {
      generalNameKey: "general_name_key",
      shortDescriptionKey: "short_description_key",
    },
  },
  keyVisual: {
    sectionKey: "keyVisual",
    sectionContent: {
      coverPhotoUploadKey: "cover_photo_upload_key",
      otherPhotoUploadKey: "other_photo_upload_key",
    },
  },
  instruction: {
    sectionKey: "instruction",
    sectionContent: {
      instructionSectionKey: "instruction_section_key",
    },
  },
  detail: {
    sectionKey: "detail",
    sectionContent: {
      detailSectionKey: "detail_section_key",
    },
  },
  validPeriod: {
    sectionKey: "validPeriod",
    sectionContent: {
      validPeriodTypeKey: "valid_period_type_key",
    }
  },
  ticketStores: {
    sectionKey: "ticketStores",
    sectionContent: {
      relatedBrandKey: "related_brand_key",
      useInOneStoreKey: "use_in_one_store_key",
    },
  },
  codeSetting: {
    sectionKey: "codeSetting",
    sectionContent: {
      redemptionMethodKey: "redemption_method_key",
      ticketSourceKey: "ticket_source_key",
    },
  },
  generateTickets: {
    sectionKey: "generateTickets",
    sectionContent: {
      generateTicketsKey: "generat_tickets_key",
    },
  },
  additionalData: {
    sectionKey: "additionalData",
    sectionContent: {
      additionalDataKey: "additional_data_key",
    }
  },
}

export const TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY = {
  requirements:{
    sectionKey: "requirements",
    sectionContent: {
      requirePointsToRedeemKey: "require_points_to_redeem_key",
      requiredPointsKey: "required_points_key",
      enableOtpKey: "enable_otp_key",
    },
  },
  timeSlot: {
    sectionKey: "timeSlot",
    sectionContent: {
      timeSlotKey: "set_linked_ticket_time_slot_key",
    },
  },
  otherInformation: {
    sectionKey: "otherInformation",
    sectionContent: {
      fillOtherInformationKey: "fill_other_info_key",
      otherInfoInputSectionKey: "other_info_input_section_key"
    },
  },
  limits: {
    sectionKey: "limits",
    sectionContent: {
      haveLimitsKey: "have_limits_key",
      couponAcquiringLimitKey: "coupon_acquiring_limit_key",
      perHeadLimitKey: "per_head_limit_key"
    },
  }
}

export const TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY = {
  content: {
    sectionKey: "perviewContent",
  },
  properties: {
    sectionKey: "perviewProperties",
  },
  detailGeneral: {
    sectionKey: "detailGeneral",
  },
}

export const eventAnchorConfig = [
  {
    title: "Campaign content",
    anchorKey: TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.content.sectionKey,
    className: "",
    sublist: [
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionKey,
        title: "General"
      },
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey,
        title: "Target customers"
      },
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
        title: "Key visual"
      },
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.instruction.sectionKey,
        title: "Instruction"
      },
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.detail.sectionKey,
        title: "Detail"
      },
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey,
        title: "Front end display"
      },
      ...(
        ProcessEnvConfig.haveShopMall
          ? [{ anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionKey, title: 'Mall' }]
          : []
      ),
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionKey,
        title: "Active period"
      },
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey,
        title: "Visible period"
      },
      {
        anchorKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
        title: "Recurring Campaign"
      },
    ]
  },
  {
    title: "Rule & Properties",
    anchorKey: TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.properties.sectionKey,
    className: "",
    sublist: [
      {
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionKey,
        title: "Requirements"
      },
      {
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionKey,
        title: "Set time slot  by linking the ticket"
      },
      {
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionKey,
        title: "Other information"
      },
      {
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionKey,
        title: "Limits"
      },
    ]
  },
];
